import { useAppContext } from '@frx/frx-react-context';
import {
  Box,
  Button,
  Heading,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { getDataTracking, sanitizeBirthDate } from '../../../../utils';
import { EditInformationModal } from './EditInformationModal';
import { Card } from '../../../../components';

export const AccountInformation = () => {
  const {
    data: {
      authData: { user },
    },
  } = useAppContext();
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <Card aria-label="Account Information Card">
      <Heading size="md" color="brand.primary.swatch1">
        Account Information
      </Heading>
      <VStack spacing={4} pt={4} pb={8} align="stretch">
        <Box aria-label="UsernameandEmail">
          <Text fontSize="24px" color="brand.additional.black">
            {user?.name?.first} {user?.name?.last}
          </Text>
          <Text fontSize="14px" color="brand.monochromatic.600">
            {user?.email?.primary_address}
          </Text>
        </Box>
        <Box aria-label="User Date of Birth">
          <Text fontSize="14px" color="brand.monochromatic.600">
            Date of Birth
          </Text>
          {user?.birth_date && (
            <Text fontSize="16px">
              {dayjs(sanitizeBirthDate(user?.birth_date || '')).format(
                'MM/DD/YYYY'
              )}
            </Text>
          )}
        </Box>
        <Box aria-label="User Address">
          <Text fontSize="14px" color="brand.monochromatic.600">
            Mailing address
          </Text>
          <Text fontSize="16px">
            {user?.primary_address?.street1}
            {user?.primary_address?.street2
              ? `, ${user?.primary_address?.street2}`
              : ``}
            <br />
            {user?.primary_address?.street3
              ? `${user?.primary_address?.street3}, `
              : ``}
            {user?.primary_address?.city} {user?.primary_address?.state}{' '}
            {user?.primary_address?.zip} <br />
            {user?.primary_address?.country}
          </Text>
        </Box>
        <Box aria-label="User Phone">
          <Text fontSize="14px" color="brand.monochromatic.600">
            Phone
          </Text>
          <Text fontSize="16px">{user?.home_phone}</Text>
        </Box>
      </VStack>
      <Button
        variant="secondary"
        colorScheme="blue"
        w="full"
        onClick={onOpen}
        {...getDataTracking('editYourInfoButton')}
      >
        Edit your information
      </Button>
      {isOpen && <EditInformationModal isOpen={isOpen} onClose={onClose} />}
    </Card>
  );
};
